<mat-dialog-content class="app-therapy-limitation-dialog__content">
    <div>
        <h2 mat-dialog-title class="app-therapy-limitation-dialog__title">
            {{
                data.therapyLimitation.id
                    ? ('apps.patient.overview.editTherapyLimitation' | translate)
                    : ('apps.patient.overview.addTherapyLimitation' | translate)
            }}
        </h2>
        <app-therapy-limitation-form
            [formGroup]="therapyLimitationForm"
            [isBedSideMode]="data.isBedSideMode"
            [isActive]="true"
        ></app-therapy-limitation-form>
    </div>

    <div class="app-therapy-limitation-dialog__actions">
        <button mat-button class="app-therapy-limitation-dialog__cancel" color="primary" mat-dialog-close>
            {{ 'apps.patient.overview.dialogCancel' | translate }}
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="submitChange()">
            {{ 'apps.patient.overview.dialogSave' | translate }}
        </button>
    </div>
</mat-dialog-content>
